import { SearchType } from './search.type';
import { SelectionModel } from '@angular/cdk/collections';

export class SearchModel {
  public type: SearchType | any;
  public keyword: string | any;
  public clinic: number | any;
  public result: any;
  public busy: any = false;
  public selectedTemplates: SelectionModel<any> | any;
  public is_pne?: boolean;

  constructor(keyword: string, type?: SearchType, result?: any, busy?: boolean, clinic?: number) {
    this.keyword = keyword;
    this.type = type;
    this.result = result;
    this.busy = busy;
    this.clinic = clinic;

    this.selectedTemplates = new SelectionModel<any>(true, []);
  }
}
